import axios, { AxiosInstance } from "axios";
import appconst from "@/lib/appconst";
import Vue from "vue";
const ajax = axios.create({
  baseURL: appconst.remoteServiceBaseUrl
});
ajax.interceptors.request.use(
  function(config) {
    if (!!window.abp.auth.getToken()) {
      config.headers.common["Authorization"] =
        "Bearer " + window.abp.auth.getToken();
    }
    config.headers.common[
      ".AspNetCore.Culture"
    ] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    config.headers.common[
      "Abp.TenantId"
    ] = window.abp.multiTenancy.getTenantIdCookie();
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
let vm = new Vue({});
ajax.interceptors.response.use(
  respon => {
    if (respon.data && respon.data.success) {
      respon.data = respon.data.result;
    }
    return respon;
  },
  error => {
    console.log(error);
    if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message &&
      error.response.data.error.details
    ) {
      const h = vm.$createElement;
      vm.$message({
        type: "error",
        message: h("p", [
          h("p", error.response.data.error.message),
          h("p", error.response.data.error.details)
        ])
      });
    } else if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message
    ) {
      vm.$message({
        type: "error",
        message: error.response.data.error.message
      });
    } else if (!error.response) {
      vm.$message({
        type: "error",
        message: window.abp.localization.localize("UnknownError")
      });
    }
    setTimeout(() => {
      // vm.$Message.destroy()
    }, 1000);
    return Promise.reject(error);
  }
);

export default class Ajax {
  public static create(): AxiosInstance {
    return ajax;
  }
}
